import { isValidMomentDate, isBoolean } from './OperatorValidators';
import { makeOperator } from './Operator';
import { RangeInputType } from '../InputTypes';
import { MomentDate } from '../DisplayTypes';
import { isValidDateWithoutYear } from '../../components/operator/AnniversaryDateInput';
export default makeOperator({
  inputType: RangeInputType,
  displayType: MomentDate,
  name: 'NotBetweenTimePoints',
  values: [{
    name: 'value',
    isValid: value => isValidMomentDate(value) || isValidDateWithoutYear(value)
  }, {
    name: 'highValue',
    isValid: value => isValidMomentDate(value) || isValidDateWithoutYear(value)
  }, {
    name: 'hasTimezones',
    isValid: isBoolean,
    defaultValue: false
  }, {
    name: 'ignoreYear',
    isValid: isBoolean,
    defaultValue: false
  }]
});